import { ApiService, WaitlistEmail } from './types';

export class NetlifyApiService implements ApiService {
  private baseURL = '/.netlify/functions';

  // Waitlist
  async addWaitlistEmail(email: string): Promise<WaitlistEmail> {
    const response = await fetch(`${this.baseURL}/waitlist`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to add email');
    }

    return response.json();
  }

  // Stubs for other methods (not needed for waitlist-only app)
  async getDoctors() { return []; }
  async getDoctor() { return null; }
  async addDoctor(): Promise<any> { throw new Error('Not implemented'); }
  async updateDoctor(): Promise<any> { throw new Error('Not implemented'); }
  async deleteDoctor(): Promise<void> { throw new Error('Not implemented'); }
  async getReviews() { return []; }
  async getDoctorReviews() { return []; }
  async addReview(): Promise<any> { throw new Error('Not implemented'); }
  async updateReview(): Promise<any> { throw new Error('Not implemented'); }
  async deleteReview(): Promise<void> { throw new Error('Not implemented'); }
}

// Export a singleton instance
export const apiService = new NetlifyApiService();

